import React from 'react';
import { Link } from 'react-router-dom';

const SessionBooking = () => {
  return (
    <div className="min-h-screen bg-gray-50 p-8">
      <div className="max-w-4xl mx-auto">
        <Link to="/services/career" className="text-indigo-600 hover:text-indigo-700 mb-4 inline-block">
          Back to Career Dashboard
        </Link>
        <h1 className="text-3xl font-bold text-gray-900 mb-4">Book a Session</h1>
        <div className="bg-white rounded-lg shadow p-6">
          <p className="text-gray-600 mb-4">
            Schedule one-on-one career counseling sessions with our experts.
          </p>
          <p className="text-sm text-gray-500">Coming soon: Session booking calendar</p>
        </div>
      </div>
    </div>
  );
};

export default SessionBooking;
